import { $3l5vvh8yg0ier as $ } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *proceedLoop($this, $completion) {
  $l$loop_0: do {
    var index = $this.index_1;
    if (index === -1) {
      break $l$loop_0;
    }
    var interceptors = $this.interceptors_1;
    if (index >= interceptors.get_size_woubt6_k$()) {
      $this.finish_mh2air_k$();
      break $l$loop_0;
    }
    var executeInterceptor = interceptors.get_c1px32_k$(index);
    $this.index_1 = index + 1 | 0;
    yield* $(executeInterceptor($this, $this.subject_1, $completion), $completion);
  }
   while (true);
  return $this.subject_1;
}
var DebugPipelineContextClass;
function DebugPipelineContext() {
  if (DebugPipelineContextClass === VOID) {
    class $ extends PipelineContext() {
      constructor(context, interceptors, subject, coroutineContext) {
        super(context);
        this.interceptors_1 = interceptors;
        this.coroutineContext_1 = coroutineContext;
        this.subject_1 = subject;
        this.index_1 = 0;
      }
      get_coroutineContext_115oqo_k$() {
        return this.coroutineContext_1;
      }
      get_subject_tmjbgd_k$() {
        return this.subject_1;
      }
      finish_mh2air_k$() {
        this.index_1 = -1;
      }
      *proceedWith_i5skhv_k$(subject, $completion) {
        this.subject_1 = subject;
        return yield* this.proceed_tynop7_k$($completion);
      }
      *proceed_tynop7_k$($completion) {
        var index = this.index_1;
        if (index < 0)
          return this.subject_1;
        if (index >= this.interceptors_1.get_size_woubt6_k$()) {
          this.finish_mh2air_k$();
          return this.subject_1;
        }
        return yield* /*#__NOINLINE__*/proceedLoop(this, $completion);
      }
      *execute_pc5rz_k$(initial, $completion) {
        this.index_1 = 0;
        this.subject_1 = initial;
        return yield* this.proceed_tynop7_k$($completion);
      }
    }
    initMetadataForClass($, 'DebugPipelineContext', VOID, VOID, VOID, [1, 0]);
    DebugPipelineContextClass = $;
  }
  return DebugPipelineContextClass;
}
//region block: exports
export {
  DebugPipelineContext as DebugPipelineContext2zfnr2i0vcihk,
};
//endregion

//# sourceMappingURL=DebugPipelineContext.mjs.map
